import NextImage from "next/image";

import React, { FC, useEffect, useState } from "react";

import { Grid, Paper, Typography, Box, Link } from "@mui/material";

import Button from "components/CustomButton";
import CustomOutlinedInput from "components/CustomOutlinedInput";

interface SectionWeCountdownProps {
  countdownTo: string; //example: "2024-03-01T18:40:59"
  team1Logo?: string;
  team2Logo?: string;
  details?: Array<{ key: string; value: string }>;
  description?: string;
  displayEmailForm?: boolean;
  additionalButton?: {
    label: string;
    href: string;
  };
}

const SectionWeCountdown: FC<SectionWeCountdownProps> = ({
  countdownTo,
  team1Logo,
  team2Logo,
  details,
  description,
  displayEmailForm,
  additionalButton,
}) => {
  function CountdownTimer({ targetDate }) {
    const calculateTimeLeft = () => {
      const difference = +new Date(targetDate) - +new Date();
      let timeLeft = {};

      if (difference > 0) {
        timeLeft = {
          D: Math.floor(difference / (1000 * 60 * 60 * 24)),
          H: Math.floor((difference / (1000 * 60 * 60)) % 24),
          Min: Math.floor((difference / 1000 / 60) % 60),
          Sec: Math.floor((difference / 1000) % 60),
        };
      }

      return timeLeft;
    };

    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

    useEffect(() => {
      const timer = setTimeout(() => {
        setTimeLeft(calculateTimeLeft());
      }, 1000);

      return () => clearTimeout(timer);
    });
    const timeDigit = (digit, index) => (
      <Paper
        key={index}
        sx={{
          width: 30,
          display: "flex",
          fontSize: 24,
          alignItems: "center",
          justifyContent: "center",
          margin: "0 0.5px",
          backgroundColor: "rgba(255, 255, 255, 0.1)",
        }}
      >
        {digit}
      </Paper>
    );

    const timeSection = (time, label) => {
      const timeString = time.toString().padStart(2, "0");
      return (
        <Grid
          item
          xs={3}
          container
          direction="column"
          alignItems="center"
          alignContent={"space-evenly"}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            {timeString
              .split("")
              .map((digit, index) => timeDigit(digit, index))}
          </Box>
          <Typography color="white" mt={1} fontSize={16}>
            {label}
          </Typography>
        </Grid>
      );
    };

    return (
      <Box>
        <Grid container display={"flex"}>
          {Object.keys(timeLeft).map((interval) => (
            <React.Fragment key={interval}>
              {timeSection(timeLeft[interval], interval.toUpperCase())}
            </React.Fragment>
          ))}
        </Grid>
      </Box>
    );
  }
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        gap: 5,
        alignItems: "center",
      }}
    >
      <Box width="100%">
        <br />
        <Grid container spacing={0}>
          <Grid item xs={6} style={{ textAlign: "center" }}>
            <NextImage
              src={team1Logo || ""}
              alt="Team 1 logo"
              width={150}
              height={150}
            />
          </Grid>
          <Grid item xs={6} style={{ textAlign: "center" }}>
            <NextImage
              src={team2Logo || ""}
              alt="Team 2 logo"
              width={150}
              height={150}
            />
          </Grid>
        </Grid>
        <br />
        <br />
        <CountdownTimer targetDate={countdownTo} />
        <br />
        {details?.map((detail) => (
          <Box sx={{ display: "flex", alignItems: "center", my: 3 }}>
            <Typography sx={{ width: "30%" }}>
              <span style={{ color: "white", fontWeight: "bold" }}>
                {detail.key + ": "}
              </span>
            </Typography>
            <Typography sx={{ ml: 2, flex: 1 }} key={detail.key}>
              {detail.value}
            </Typography>
          </Box>
        ))}
        <Typography paragraph mb={3}>
          {description}
        </Typography>
        {displayEmailForm && (
          <Box sx={{ mb: 5, mt: 2 }}>
            <CustomOutlinedInput
              label="Email"
              type="email"
              inputProps={{
                placeholder: "Email",
              }}
            />
            <Button
              className="button"
              href={"https://warsaweagles.com/"}
              target="_blank"
              sx={{
                marginTop: 2,
              }}
            >
              CONFIRM MY PRESENCE
            </Button>
          </Box>
        )}
        {additionalButton && (
          <Box
            sx={{
              mx: "auto",
              alignItems: "center",
              textAlign: "center",
              maxWidth: "60%",
            }}
          >
            <Link href={additionalButton.href} target="_blank">
              {additionalButton.label}
            </Link>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default SectionWeCountdown;
